/**
 * PRD Part 15 — invoice == job. Both routes open the same record.
 *
 * `/invoices/{iid}` used to render a separate InvoiceForm component, which is
 * legacy. Now we resolve the invoice id through the unified resolver and
 * navigate to `/jobs/{job_id}` so there's exactly one detail UI.
 *
 * Falls back to `InvoiceForm` if the id can't be resolved to a job — this
 * keeps any historical orphan rows from 404'ing.
 */
import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import api from "../lib/apiClient";
import { InvoiceForm } from "./Invoices";

export default function InvoiceRedirect() {
  const { id } = useParams();
  const [target, setTarget] = useState(undefined); // undefined = loading, null = no redirect, string = redirect path

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Unified resolver: GET /api/invoices/:id returns the underlying job's id
        const { data } = await api.get(`/invoices/${id}`);
        if (cancelled) return;
        // job_as_invoice() maps the invoice id to the JOB's id under unified arch
        const jobId = data?.job_id || data?.id || id;
        setTarget(`/jobs/${jobId}`);
      } catch {
        if (!cancelled) setTarget(null); // fall back to legacy form
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (target === undefined) {
    return (
      <div className="text-sm text-slate-500 p-6">Loading invoice…</div>
    );
  }
  if (target) return <Navigate to={target} replace />;
  return <InvoiceForm />;
}
